module.exports = __webpack_public_path__ + "media/src/images/icons/loading_primary-8cf3cc09e2f8b91076260461f5689b41.svg";